import ApiCore from "./api_core"
import { EncounterI, EncounterCountParamsI, EncounterFiltersI, UpdateEncounterI, NewEncounterI } from "./types"

export default new class {
    all(params={} as EncounterFiltersI) {
        return ApiCore.getJson<EncounterI[]>('encounters', params)
    }

    get(id: number) {
        return ApiCore.getJson<EncounterI>(`encounters/${id}`)
    }

    /**
        Generate a report on counts of various encounters
        POST /reports/encounters
        Optional parameters:
            all - Retrieves all encounters not just those created by current user
     */
    count(params: EncounterCountParamsI) {
        return ApiCore.postJson<Record<string, { M?: number; F?: number}>>('reports/encounters', params)
    }

    create(encounter: NewEncounterI) {
        return ApiCore.postJson<EncounterI>('encounters', encounter)        
    }

    update(id: number, encounter: UpdateEncounterI) {
        return ApiCore.putJson<EncounterI>(`encounters/${id}`, encounter)
    }

    void(id: number, reason: string) {
        return ApiCore.void(`encounters/${id}`, { reason })
    }
}
